import type { AdPlacement, HouseAd } from '@/lib/services/store.service';

/**
 * Escolhe o anúncio próprio do espaço: sorteio ponderado pelo peso entre as
 * campanhas da posição e do idioma, sem repetir campanha já mostrada na mesma
 * página. Sem candidata, null (o espaço some).
 */
export function escolherAnuncio(
  anuncios: HouseAd[],
  posicao: AdPlacement,
  idioma: string,
  jaNaPagina: ReadonlySet<string>,
  sorteio: () => number = Math.random,
): HouseAd | null {
  const lingua = idioma.slice(0, 2).toLowerCase();
  const candidatas = anuncios.filter(
    (a) =>
      a.placements.includes(posicao) &&
      !jaNaPagina.has(a.id) &&
      (a.locales.length === 0 || a.locales.includes(lingua)) &&
      !!imagensDaPosicao(a, posicao).principal,
  );
  if (candidatas.length === 0) return null;
  const total = candidatas.reduce((soma, a) => soma + Math.max(1, a.weight), 0);
  let alvo = sorteio() * total;
  for (const a of candidatas) {
    alvo -= Math.max(1, a.weight);
    if (alvo < 0) return a;
  }
  return candidatas[candidatas.length - 1];
}

/**
 * As imagens que a posição desenha: cada posição tem a sua (GIF chega como
 * WebP animado). `celular` é opcional; sem ela o celular usa a principal.
 */
export function imagensDaPosicao(anuncio: HouseAd, posicao: AdPlacement): { principal: string | null; celular: string | null } {
  if (posicao === 'IN_FEED') return { principal: anuncio.imageSquareUrl, celular: null };
  if (posicao === 'ARTICLE_END') return { principal: anuncio.imageArticleUrl ?? null, celular: anuncio.imageArticleMobileUrl ?? null };
  return { principal: anuncio.imageUrl, celular: anuncio.imageMobileUrl };
}
